"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Hotkey = _interopRequireDefault(require("../Hotkey"));

require("./button.sass");

var Button =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Button, _Component);

  function Button() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Button)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleClick", function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick;

      if (disabled) {
        e.preventDefault();
      }

      !disabled && onClick && onClick(e);
    });
    return _this;
  }

  (0, _createClass2.default)(Button, [{
    key: "getClassName",
    value: function getClassName() {
      var _this$props2 = this.props,
          hidden = _this$props2.hidden,
          className = _this$props2.className,
          flat = _this$props2.flat,
          active = _this$props2.active,
          small = _this$props2.small,
          primary = _this$props2.primary,
          toggler = _this$props2.toggler,
          borderless = _this$props2.borderless,
          disabled = _this$props2.disabled;
      return (0, _classnames.default)('btn', className, {
        'hidden': hidden,
        'btn--flat': flat,
        'btn--primary': primary,
        'btn--small': small,
        'btn--active': active,
        'btn--borderless': borderless,
        'btn--disabled': disabled,
        'btn--toggler': toggler
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          Icon = _this$props3.Icon,
          children = _this$props3.children,
          disabled = _this$props3.disabled,
          type = _this$props3.type,
          href = _this$props3.href,
          label = _this$props3.label,
          element = _this$props3.element,
          shortcut = _this$props3.shortcut,
          download = _this$props3.download,
          onMouseDown = _this$props3.onMouseDown,
          onMouseUp = _this$props3.onMouseUp,
          currentTab = _this$props3.currentTab;
      var inner = label ? label : children;

      var content = _react.default.createElement("span", {
        className: "btn-content"
      }, Icon && _react.default.createElement(Icon, {
        className: 'btn-icon ' + (inner ? 'btn-icon--offset' : '')
      }), inner, shortcut && _react.default.createElement(_Hotkey.default, {
        shortcut: shortcut,
        action: this.handleClick
      }));

      var buttonProps = {
        type: type,
        disabled: disabled,
        onClick: this.handleClick,
        className: this.getClassName(),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp
      };
      buttonProps.children = content;

      if (href) {
        element = 'a';
        buttonProps.target = currentTab ? '_top' : '_blank';
        buttonProps.href = href;
        buttonProps.download = download;
      }

      return _react.default.createElement(element, buttonProps);
    }
  }]);
  return Button;
}(_react.Component);

exports.default = Button;
(0, _defineProperty2.default)(Button, "defaultProps", {
  element: 'button',
  type: 'button'
});
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes.default.string,
  href: _propTypes.default.string,
  Icon: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
  shortcut: _propTypes.default.string,
  hidden: _propTypes.default.bool,
  flat: _propTypes.default.bool,
  active: _propTypes.default.bool,
  small: _propTypes.default.bool,
  primary: _propTypes.default.bool,
  borderless: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  toggler: _propTypes.default.bool,
  element: _propTypes.default.string,
  type: _propTypes.default.string,
  onClick: _propTypes.default.func,
  label: _propTypes.default.string,
  download: _propTypes.default.bool,
  onMouseDown: _propTypes.default.func,
  onMouseUp: _propTypes.default.func,
  currentTab: _propTypes.default.bool
} : {};